import type { IChatPage } from "./types";

/** Next page number, or undefined on the last page. */
const nextPage = <T>(lastPage: IChatPage<T>): number | undefined => {
  const pagination = lastPage.pagination;
  return pagination && pagination.page < pagination.total_pages
    ? pagination.page + 1
    : undefined;
};

const flatten = <T>(pages: IChatPage<T>[] | undefined): T[] =>
  pages?.flatMap((page) => page.data) ?? [];

export const chatService = { nextPage, flatten };
